import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import ImageComponent from "../../component/core/image";
import ImageComplaintsHeader from "src/assets/image/complaints-page-image/img-complaints-header.png";
import ImageComplaintsProcess from "src/assets/image/complaints-page-image/img-complaints-process.png";

export default function Content() {

    const { t } = useTranslation();

    return (
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24 w-full">
            <div className="flex flex-col gap-6 sm:gap-8">
                <div className="w-full mx-auto overflow-hidden rounded-2xl max-w-[900px]" >
                    <ImageComponent
                        src={ImageComplaintsHeader}
                        alt="image-complaints-header"
                        className="w-full h-auto object-contain"
                    />
                </div>
                <div className="w-full mx-auto overflow-hidden rounded-2xl max-w-[1280px]" >
                    <ImageComponent
                        src={ImageComplaintsProcess}
                        alt="image-complaints-process"
                        className="w-full h-auto object-contain"
                    />
                </div>
            </div>
        </div>
    );
}
